import { MORTGAGE_PROMO_TYPES } from '../../constants/promos';
import { IPromoInfoSchema } from '../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';
import { IApplicationState } from '../../types/redux';

export const selectMortgagePromos = (state: IApplicationState): IPromoInfoSchema[] => {
  const promos: IPromoInfoSchema[] = state.newbuilding.promoInfos || [];

  return promos.filter(promo => MORTGAGE_PROMO_TYPES.includes(promo.promoType));
};
